import React, {useState} from 'react';
import {Route} from 'react-router-dom';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import ShareViaEmailModal from './ShareViaEmailModal';
import ShareViaSmsModal from './ShareViaSmsModal';

const SocialActions = ({className, onActionCompleted}) => {
  const cssBEM = 'socialActions';
  const classes = classnames(cssBEM, className);

  const [smsOpen, setSmsOpen] = useState(false);
  const [shareViaEmailOpen, setShareViaEmailOpen] = useState(false);

  const onPrintClick = () => {
    onActionCompleted('printButtonClicked')
    window.print();
  };

  return (
    <Route path={["/guide/:uuid/summary", "/guide/:uuid/details"]} children={({match}) => {
      return match ? <div className={classes}>
        <ul>
          <li className={`${cssBEM}__email`}>
            <a href="#!" onClick={() => setShareViaEmailOpen(true)}>
              <img src="/classpath/assets/images/header-email.svg"/>
              <FormattedMessage id="summary.headerMenu.email" tagName="span"/>
            </a>
          </li>
          <li className={`${cssBEM}__sms`}>
            <a href="#!" onClick={() => setSmsOpen(true)}>
              <img src="/classpath/assets/images/header-sms.svg"/>
              <FormattedMessage id="summary.headerMenu.sms" tagName="span"/>
            </a>
          </li>
          <li className={`${cssBEM}__print`}>
            <a href="#!" onClick={onPrintClick}>
              <img src="/classpath/assets/images/header-print.svg"/>
              <FormattedMessage id="summary.headerMenu.print" tagName="span"/>
            </a>
          </li >
        </ul>
        <ShareViaEmailModal active={shareViaEmailOpen} onClose={() => {setShareViaEmailOpen(false);}} />
        <ShareViaSmsModal active={smsOpen} onClose={() => {setSmsOpen(false);}} />
      </div> : null
    }}
    />
  );
};

export default SocialActions;
